module.exports = __webpack_public_path__ + "media/clairiere.9da4cb2c.mp3";